import {Box} from 'src/design/atoms/Box';
import React from 'react';
import type {
  CourseDefinitionQuizQuestionAnswerResponse,
  CourseDefinitionQuizQuestionResponse} from 'src/api/ProactApiClient';
import {
  CourseDefinitionQuizQuestionTypeEnum,
} from 'src/api/ProactApiClient';
import {FormRadioGroup} from 'src/app/forms/FormRadioGroup';
import type {ISelectOption} from 'src/types/Form';
import type {IFormDataV2} from 'src/types/FormV2';
import {QuestionAnswersForm} from '../courseDefinition/QuestionAnswersForm';
import {QuestionForm} from '../courseDefinition/QuestionForm';

const QuestionOptions: ISelectOption[] = [
  {
    id: CourseDefinitionQuizQuestionTypeEnum.SingleChoice,
    label: 'Single Select',
  },
  {
    id: CourseDefinitionQuizQuestionTypeEnum.MultiChoice,
    label: 'Multi Select',
  },
];

export interface EditCourseDefinitionQuestionProps {
  question: CourseDefinitionQuizQuestionResponse;
  index: number;
  onQuestionChange: (
    obj: CourseDefinitionQuizQuestionResponse,
    index: number
  ) => void;
}
const EditCourseDefinitionQuestion: React.FC<
  EditCourseDefinitionQuestionProps
> = ({question, index, onQuestionChange}) => {
  const handleQuestionTypeChange = (value: string) => {
    onQuestionChange(
      {
        ...question,
        type: Number(value) as CourseDefinitionQuizQuestionTypeEnum,
      },
      index
    );
  };

  const handleFormDataChange = (data: IFormDataV2) => {
    onQuestionChange(
      {
        ...question,
        labelText: data.labelText,
        bodyText: data.bodyText,
        scoreValue: data.scoreValue,
      },
      index
    );
  };

  const handleAnswersChange = (
    answers: CourseDefinitionQuizQuestionAnswerResponse[]
  ) => {
    onQuestionChange(
      {
        ...question,
        answers: answers,
      },
      index
    );
  };

  return (
    <Box>
      <FormRadioGroup
        label="Question Type"
        value={question.type}
        options={QuestionOptions}
        onChange={handleQuestionTypeChange}
        helpText="Question type does not limit the number of questions you may select as 'correct'."
      />
      <QuestionForm
        data={question}
        mode="edit"
        onFormDataChange={handleFormDataChange}
      />
      <QuestionAnswersForm
        data={question.answers ?? []}
        mode="edit"
        onChange={handleAnswersChange}
      />
    </Box>
  );
};

export default EditCourseDefinitionQuestion;
